export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";